var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128013(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128-013-1{fill:#fff;}.cls-128-013-2,.cls-128-013-3{fill:none;}.cls-128-013-2{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-013-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-013-2",
    points: "13.42 31.73 13.42 13.34 31.82 13.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-013-2",
    points: "96.19 13.34 114.58 13.34 114.58 31.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-013-2",
    points: "31.82 114.5 13.42 114.5 13.42 96.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-013-2",
    points: "114.58 96.11 114.58 114.5 96.19 114.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M90.71,73.77c-.55,4.14-.62,7.82,1.62,8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M66.21,34a37.71,37.71,0,0,1,7.37.95c13.66,3,20.31,14.35,18.28,31.2-.09.75-.2,1.54-.33,2.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M29.31,58C40.89,56.32,44,38,60.08,34.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M83.18,51.1c2.84,5.57,3.08,13.17,1.24,21.65-2.29,10.58-.3,15.57,3.16,16.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M28,67.87C46.07,66,47.05,35,72.82,42.68a17.4,17.4,0,0,1,6.63,3.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M75.6,78.83c-.46,11.4,2.36,14.32,5.83,17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M50.39,58.2C56,51.29,62.17,47.4,70,50.68c10.75,4.49,7.85,14,6.3,22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M28,76.19s9.73,1.5,16.88-10c.45-.73.91-1.45,1.37-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M53.72,93.23a28.87,28.87,0,0,1-11.9,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M43.2,79.14C54.34,71.08,57,55.62,66.9,58.3c6.92,1.26,3.58,20-8.46,31.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M31,83.66a25.31,25.31,0,0,0,6.9-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M33.62,90.84c11.5-1,24.49-8,30.43-24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M48.8,102.23c7.58-1,10.07-3.57,12.24-6.35,1.46-1.87,3-1.82,3.4-.41.9,3.22.58,6.12,3.65,7.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M69.13,86c-.82,8.44,3.37,13.79,5.39,14.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M96.43,44.51c4.76,12.59,1,27.35,1,27.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M40.54,39.63c7-8.54,18.15-18.29,40.19-10.5A24.91,24.91,0,0,1,94,39.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-013-2",
    d: "M30.79,49.63c1.86-.13,3.72-2.29,6-5.24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128013);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_013.8df1747b7db7f5cb4f350a27428d564b.svg";
export { ForwardRef as ReactComponent };